import { API_JWT_BASE_URL } from '../http'

export const SEARCH_LOGFILES_API = `${API_JWT_BASE_URL}/admin/logfiles/search`
export const DOWNLOAD_LOG_FILES_API = `${API_JWT_BASE_URL}/admin/logfiles/`

export const LOGFILES_QUERY_KEYS = {
  SEARCH_LOGFILES: 'SEARCH_LOGFILES',
  DOWNLOAD_LOGFILES: 'DOWNLOAD_LOGFILES',
  DOWNLOAD_A_LOGFILE: 'DOWNLOAD_A_LOGFILE'
}
